import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Search from '../../../searchField';


const TextTabs = ({ t,
  addPlaceholder,
  activeItem,
  showItem,
  cssClass,
  addNew,
  search,
  service,
  searchProps,
  data }) => (
    <React.Fragment>
      <ul className={cssClass || 'surveytabs boxs simplepagetab'}>
        <li>
          <a
            href="#"
            onClick={e => addNew(e)}
            className="form-control"
          >{addPlaceholder || t('Title of new page')}
          </a>
        </li>
        {search &&
          <li>
            <Search {...searchProps} />
          </li>}
        {
            data.length ? data.map(item => (
              <li key={item.id}>
                <a
                  href="#"
                  className={`tablinks ${(activeItem && activeItem.id === item.id) ? 'active' : ''}`}
                  onClick={e => showItem(e, item)}
                >
                  {item.message}
                  <div className="boxs">
                    <span className="tym">{moment(item.created_at).format('ll')}</span>
                    <span className={`tickettag st-${service.getColorByStatus(item.status)}`}>{service.getStatusList(t)[item.status]}</span>
                  </div>
                </a>
              </li>
      ))
                :
            ''
    }
      </ul>
    </React.Fragment>
);

TextTabs.propTypes = {
  t: PropTypes.func.isRequired,
};

export default TextTabs;



// WEBPACK FOOTER //
// ./src/components/modules/textTabs/simple/TextTabs.jsx